import SiteSearchBox from './SiteSearchBox';

export { type SiteSearchBoxProps } from './SiteSearchBox';
export default SiteSearchBox;
